import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faExclamationCircle, faInfoCircle, faSpinner, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import TableValidLicensePlates from 'screens/vehicles-import/TableValidLicensePlates';
import TableInvalidLicensePlates from 'screens/vehicles-import/TableInvalidLicensePlates';
import { getAllTelematicTypeMetadata } from '../../features/company/companyDetails';
import { ReduxState } from 'types';


const ImportRequestValidationResult = props => {
    useEffect(() => {
        if (props.licensePlatesImports.validationResult.requests.length) {
            document.getElementById('import-request-validation-result-box').scrollIntoView({ behavior: 'smooth' });
        }
    }, []);

    const invalidImportRequests = props.licensePlatesImports.validationResult.invalidImportRequests;
    const validImportRequests = props.licensePlatesImports.validationResult.validImportRequests;

    return (
        <div id="import-request-validation-result-box" className="radius-rectangle pad-20">
            {props.importingStatus.error && (
                <p className="red-box">
                    <FontAwesomeIcon icon={faTimesCircle} className="fa-icon" />
                    <FormattedMessage id="ERROR_SOMETHING_WENT_WRONG" />
                </p>
            )}

            {validImportRequests.length ? (
                <p className="blue-box">
                    <FontAwesomeIcon icon={faInfoCircle} className="fa-icon" />
                    <FormattedMessage id="IMPORT_VALIDATION_RESULT_INSTRUCTIONS" />
                </p>
            ) : (
                <p className="red-box">
                    <FontAwesomeIcon icon={faInfoCircle} className="fa-icon" />
                    <FormattedMessage id="IMPORT_VALIDATION_RESULT_INSTRUCTIONS_NO_VALID_LICENSE_PLATES" />
                </p>
            )}

            <h3 className="bold-title red">
                <FontAwesomeIcon icon={faExclamationCircle} className="fa-icon" />
                <FormattedMessage id="INVALID_LICENSE_PLATES" />: {invalidImportRequests.length}
            </h3>
            <TableInvalidLicensePlates importRequests={invalidImportRequests} telematicTypesMetadata={props.telematicTypesMetadata} />

            {!!validImportRequests.length && (
                <React.Fragment>
                    <h3 className="bold-title green-contrast">
                        <FontAwesomeIcon icon={faCheckCircle} className="fa-icon" />
                        <FormattedMessage id="VALID_LICENSE_PLATES" />: {validImportRequests.length}
                    </h3>
                    <TableValidLicensePlates importRequests={validImportRequests} />

                    <div className="align-right">
                        <button type="button" className="btn-blue" onClick={props.importValidLicensePlates}>
                            {props.importingStatus.importing ? (
                                <React.Fragment>
                                    <FontAwesomeIcon icon={faSpinner} className="fa-icon rotating-spinner" />
                                    <FormattedMessage id="IMPORTING_LICENSE_PLATES" />
                                </React.Fragment>
                            ) : (
                                <FormattedMessage id="IMPORT_VALID_LICENSEPLATES" />
                            )}
                        </button>
                    </div>
                </React.Fragment>
            )}
        </div>
    );
};

function mapStateToProps(state: ReduxState) {
    return {
        licensePlatesImports: state.licensePlatesImports,
        importingStatus: state.licensePlatesImports.importingStatus,
        telematicTypesMetadata: getAllTelematicTypeMetadata(state)
    };
}

export default connect(
    mapStateToProps,
    null
)(ImportRequestValidationResult);
